import { useEffect, useState } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommentFocusRequests, ICommentFocusRequest } from './CommentFocusRequests';

// Whether a note view should focus its comment bar. It latches on a request it has not acted on
// before and stays so while the view is mounted, even while the address carries no request (the
// note's editor stacked over a care map route view), so returning to the view changes nothing.
export const useFocusCommentOnce = (request?: ICommentFocusRequest): boolean => {
    const requests = useInstance(CommentFocusRequests);
    const [latched, setLatched] = useState<ICommentFocusRequest | undefined>(() => requests.isPending(request) ? request : undefined);

    // a view reused for a new request
    if (request !== undefined && request !== latched && requests.isPending(request)) {
        setLatched(request);
    }

    useEffect(() => {
        if (request !== undefined) {
            requests.markHandled(request);
        }
    }, [request, requests]);

    return latched !== undefined;
};
